import { render, staticRenderFns } from "./InvitationPreview.vue?vue&type=template&id=26ea61e4&scoped=true&"
import script from "./InvitationPreview.vue?vue&type=script&lang=ts&"
export * from "./InvitationPreview.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationPreview.vue?vue&type=style&index=0&id=26ea61e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ea61e4",
  null
  
)

export default component.exports